<!-- <div class="feature_outer_section">
    <div class="feature_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>高级写作需要高级检查，<span class="OpenSansFonts">Trinka</span>出场</h2>
                    <p>学术写作需要清晰、简洁、正式、客观和可读。</p>
                    <p><span class="OpenSansFonts">Trinka</span>可以帮助您改善所有这些方面，让您得到写作的最佳版本。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="feature_cards">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>高级语法
                        </h3>
                        <p><span class="OpenSansFonts">Trinka</span>可以纠正3000多种其他工具无法识别的复杂语法错误。 有了<span class="OpenSansFonts">Trinka</span>，写作就能清晰明了。</p>
                        <a data-toggle="modal" data-target="#Advanced_Grammar">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>句子结构</h3>
                        <p><span class="OpenSansFonts">Trinka</span>会参考您的专业正确构建句子，使您的写作易于理解。</p>
                        <a data-toggle="modal" data-target="#Sentence_Structure">参见示例</a>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>词语选择</h3>
                        <p><span class="OpenSansFonts">Trinka</span>会修改导致表达不清楚的单词。使用<span class="OpenSansFonts">Trinka</span>可以帮助您准确而清晰地表达自己的意图。</p>
                        <a data-toggle="modal" data-target="#Word_Choice">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>用法和风格</h3>
                        <p><span class="OpenSansFonts">Trinka</span>纠正措辞，使您的写作更正式。用大胆精准的语言打动您的读者。</p>
                        <a data-toggle="modal" data-target="#Usage_Style">参见示例</a>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>美式/英式风格</h3>
                        <p>在美式和英式英语之间进行选择，<span class="OpenSansFonts">Trinka</span>可以让您的写作适合读者和期刊风格。</p>
                        <a data-toggle="modal" data-target="#US_UK_Style">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>高级拼写</h3>
                        <p><span class="OpenSansFonts">Trinka</span>的上下文拼写检查可以根据学科专业领域选择正确的单词，让您不再有难堪的拼写错误。</p>
                        <a data-toggle="modal" data-target="#Advanced_Spelling">参见示例</a>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="feature_cards_heading Enhancements_text_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>帮您提高文章的写作水平，做好出版准备</h2>
                    <p><span class="OpenSansFonts">Trinka</span>可以根据学术出版标准来提高您文章的语调，表达和措辞。 有了<span class="OpenSansFonts">Trinka</span>，学术写作变得前所未有的轻松。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="feature_cards card_background_color">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>选定风格指南 <span>Trinka独家功能</span> </h3>
                        <p><span class="OpenSansFonts">Trinka</span>能根据<span class="OpenSansFonts">AMA</span>和<span class="OpenSansFonts">APA</span>等风格指南建议文句用字，使用<span class="OpenSansFonts">Trinka</span>做好发表文章的准备。</p>
                        <a data-toggle="modal" data-target="#Style_guide_preferences">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>字数缩减 <span>Trinka独家功能</span></h3>
                        <p><span class="OpenSansFonts">Trinka</span>可以帮您简化冗长的词组，轻松满足期刊指南！</p>
                        <a data-toggle="modal" data-target="#Word_count_reduction">参见示例</a>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>无偏见的语言 <span>Trinka独家功能</span> </h3>
                        <p><span class="OpenSansFonts">Trinka</span>会纠正有偏见和敏感的语言。使用<span class="OpenSansFonts">Trinka</span>能够避免批评并且有效地表达自己的观点。</p>
                        <a data-toggle="modal" data-target="#Unbiased_language">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>语意模糊 <span>Trinka独家功能</span> </h3>
                        <p><span class="OpenSansFonts">Trinka</span>可以让您的写作更加具体和直接，轻松达到有效沟通。</p>
                        <a data-toggle="modal" data-target="#Vague_language">参见示例</a>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>专业领域的措辞</h3>
                        <p><span class="OpenSansFonts">Trinka</span>会根据您的专业领域建议正确的词语，让您的写作内容与读者建立连接。</p>
                        <a data-toggle="modal" data-target="#Technical_phrasing">参见示例</a>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>学术语调</h3>
                        <p><span class="OpenSansFonts">Trinka</span>为您的作品提供正式的语调，给读者留下深刻的印象。专业写作现在变得很容易！</p>
                        <a data-toggle="modal" data-target="#Academic_tone">参见示例</a>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="feature_cards_heading understand_results">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>结果易于理解并帮助学习</h2>
                    <p><span class="OpenSansFonts">Trinka</span>旨在使您的学术写作体验流畅而轻松。与您一起工作，以确保您在需要时获得帮助。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="feature_cards">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="inner_card_contents">
                        <h3>详细说明 </h3>
                        <p><span class="OpenSansFonts">Trinka</span>提供了详细的说明、建议、和写作技巧。每次使用<span class="OpenSansFonts">Trinka</span>，您的写作技巧都会得到提高。</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="inner_card_contents odd_cards">
                        <h3>准确的建议</h3>
                        <p><span class="OpenSansFonts">Trinka</span>专为正式写作设计。在提高您写作质量的同时，也让您学会学术写作的细微差别。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>



<div class="modal features_modals" id="Advanced_Grammar">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>Neither the healthy individuals nor the patient <span class="wrong_text">recognize</span> <span class="right_text">recognizes</span>the visual discrepancies.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Sentence_Structure">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>The students don't enjoy <span class="wrong_text">to go</span> <span class="right_text">going</span> over the same rules again and again.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Word_Choice">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>One of the reasons is <span class="wrong_text">because</span> <span class="right_text">that</span> the fabrication cost <span class="wrong_text">for</span> <span class="right_text">of</span> steel members depends upon the material.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Usage_Style">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>However, his method is novel and is <span class="wrong_text">very much</span> <span class="right_text">considerably</span> different from the classical method.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="US_UK_Style">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>The upper limbs of the patient were <span class="wrong_text">paralysed</span> <span class="right_text">paralyzed.</span></p>
            </div>
        </div>
    </div>
</div>


<div class="modal features_modals" id="Advanced_Spelling">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>The <span class="wrong_text">Bonferoni</span> <span class="right_text">Bonferroni</span> test was used to check for statistical significance.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Style_guide_preferences">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>The man <span class="wrong_text">suffered from</span> <span class="right_text">had</span> chronic kidney disease.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Word_count_reduction">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>Bcl6 deficiency in T cells resulted in <span class="wrong_text">the reduction of</span> <span class="right_text">reduced</span> mRNA expression.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Unbiased_language">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>The <span class="wrong_text">retarded children</span> <span class="right_text">children with mental
                        retardation</span> were taken to a different facility.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Vague_language">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p><span class="wrong_text">Some studies</span> <span class="right_text">Studies</span> have shown that children not participating in co-curricular activities may not develop the necessary social skills in adulthood.</p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Technical_phrasing">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric <span class="wrong_text">transverse myelitis with long
                    spinal cord lesions</span> <span class="right_text">longitudinally extensive transverse myelitis</span>.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="modal features_modals" id="Academic_tone">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <p>Children actively engage in activities <span class="wrong_text">like</span> <span class="right_text">such as</span> outdoor games, skits, and other team activities.</p>
            </div>
        </div>
    </div>
</div> -->

<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka的主要功能</h1>
                        <p>Trinka是专为学术和技术写作而定制的语法和语言增强工具。它的与众不同之处在于它可以与作者协同工作，其功能超越了语法和拼写检查的范围，能确保整体语言的增强。</p>
                        <!-- <a id="FeaturesGetStarted" href="https://cloud.trinka.ai/signin?_rg=CN" target="_blank">Get Started</a> -->
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/FeaturesTopBanner.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section backgrondSecitons_outer">
        <div class="container">
            <div class="row">
                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>高级写作需要高级检查，Trinka出场</h2>
                        <div class="HeadingSubLine"></div>
                        <p>学术写作需要清晰、简洁、正式、客观和可读。Trinka可以帮助您改善所有这些方面，让您得到写作的最佳版本。</p>
                    </div>
                </div>
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="spellcheckGrammerCheck" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="0" class="active">
                                        <span></span>
                                        高级语法
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="1">
                                        <span></span>
                                        句子结构
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="2">
                                        <span></span>
                                        词语选择
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="3">
                                        <span></span>
                                        用法和
                                        <br />风格
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="4">
                                        <span></span>
                                        美式/英式
                                        <br />风格
                                    </li>
                                    <li data-target="#spellcheckGrammerCheck" data-slide-to="5">
                                        <span></span>
                                        高级拼写
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>高级语法</h4>
                                    <p>Trinka可以纠正3000多种其他工具无法识别的复杂语法错误。 有了Trinka，写作就能清晰明了。</p>
                                    <div class="featuresExampleText">
                                        <p>Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>句子结构</h4>
                                    <p>Trinka会参考您的专业正确构建句子，使您的写作易于理解。</p>
                                    <div class="featuresExampleText">
                                        <p>The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>词语选择</h4>
                                    <p>Trinka会修改导致表达不清楚的单词。使用Trinka可以帮助您准确而清晰地表达自己的意图。</p>
                                    <div class="featuresExampleText">
                                        <p>One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>用法和风格</h4>
                                    <p>Trinka纠正措辞，使您的写作更正式。用大胆精准的语言打动您的读者。</p>
                                    <div class="featuresExampleText">
                                        <p>However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>美式/英式风格</h4>
                                    <p>在美式和英式英语之间进行选择，Trinka可以让您的写作适合读者和期刊风格。</p>
                                    <div class="featuresExampleText">
                                        <p>The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>高级拼写</h4>
                                    <p>Trinka的上下文拼写检查可以根据学科专业领域选择正确的单词，让您不再有难堪的拼写错误。</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider">
        <div class="container">
            <div class="row">
                <div class="col-xl-7">
                    <div class="spellcheckGrammerCheck_slider">
                        <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                            <!-- Indicators -->
                            <div class="bullet_points_sections">
                                <ul class="carousel-indicators">
                                    <li data-target="#publishEnhancements" data-slide-to="0" class="active">
                                        <span></span>
                                        选定
                                        <br />风格指南
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="1">
                                        <span></span>
                                        字数缩减
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="2">
                                        <span></span>
                                        无偏见的
                                        <br />语言
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="3">
                                        <span></span>
                                        语意模糊
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="4">
                                        <span></span>
                                        专业领域的
                                        <br />措辞
                                    </li>
                                    <li data-target="#publishEnhancements" data-slide-to="5">
                                        <span></span>
                                        学术语调
                                    </li>
                                </ul>
                            </div>

                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <h4>选定风格指南</h4>
                                    <p>Trinka能根据AMA和APA等风格指南建议文句用字，使用Trinka做好发表文章的准备。</p>
                                    <div class="featuresExampleText">
                                        <p>The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>字数缩减</h4>
                                    <p>Trinka可以帮您简化冗长的词组，轻松满足期刊指南！</p>
                                    <div class="featuresExampleText">
                                        <p>Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>无偏见的语言</h4>
                                    <p>Trinka会纠正有偏见和敏感的语言。使用Trinka能够避免批评并且有效地表达自己的观点。</p>
                                    <div class="featuresExampleText">
                                        <p>The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>语意模糊</h4>
                                    <p>Trinka可以让您的写作更加具体和直接，轻松达到有效沟通。</p>
                                    <div class="featuresExampleText">
                                        <p>
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.</p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>专业领域的措辞</h4>
                                    <p>Trinka会根据您的专业领域建议正确的词语，让您的写作内容与读者建立连接。</p>
                                    <div class="featuresExampleText">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <h4>学术语调</h4>
                                    <p>Trinka为您的作品提供正式的语调，给读者留下深刻的印象。专业写作现在变得很容易！</p>
                                    <div class="featuresExampleText">
                                        <p>Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-5">
                    <div class="spellcheck_heading">
                        <h2>帮您提高文章的写作水平，做好出版准备</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以根据学术出版标准来提高您文章的语调，表达和措辞。 有了Trinka，学术写作变得前所未有的轻松。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>作者套餐</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set bg-right-position d-flex align-items-center" style="background-image: url('../../../assets/images/Reverstoolbox_backgrond_keyBenafits.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content pc-check-img">
                            <img src="assets/images/pc-checker.png" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>抄袭检测</h3>
                            <p>
                                通过更先进的文本相似性检测算法iThenticate和覆盖所有科学领域的最大付费出版物数据库，体验高质量的抄袭检查。
                            </p>
                            <a [routerLink]="['/features/plagiarism-check']">
                                了解更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>自动文件编辑</h3>
                            <p>继续在您喜欢的环境中工作。上传您的MS Word文档，Trinka会在几分钟内自动编辑您的论文。您可以下载文件并显示修订。</p>
                            <a [routerLink]="['/features/auto-file-edit']">
                                阅读更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="assets/images/autoFileEdit_image.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections sections_height_set">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                            <!-- <img src="assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                            <ul>
                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/JournalScope.svg" alt="">
                                    </div>
                                    <h3>期刊范围匹配</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/TechnicalCompliance.svg" alt="">
                                    </div>
                                    <h3>技术合规</h3>
                                    <span>3 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/EthicalCompliance.svg" alt="">
                                    </div>
                                    <h3>道德合规</h3>
                                    <span>5 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/AuthorshipDetails.svg" alt="">
                                    </div>
                                    <h3>作者详细信息</h3>
                                    <span>4 Checks</span>
                                </li>
                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/ReferenceDetails.svg" alt="">
                                    </div>
                                    <h3>参考文献的细节</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/FirgureTable.svg" alt="">
                                    </div>
                                    <h3>图表</h3>
                                    <span>2 Checks</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/ClinicalTrials.svg" alt="">
                                    </div>
                                    <h3>临床试验信息</h3>
                                    <span>1 Check</span>
                                </li>

                                <li>
                                    <div class="checks_icons">
                                        <img src="assets/images/KeywordsAndSummary.svg" alt="">
                                    </div>
                                    <h3>关键字和摘要</h3>
                                    <span>2 Checks</span>
                                </li>
                                <i></i>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>出版准备检查</h3>
                            <p>使用Trinka的出版准备检查，您可以通过从“期刊选择”到“道德合规”的20多项检查评估您的文档，从而增加论文被期刊录用的机会。</p>
                            <!-- <b style="font-weight: 600;">Coming soon</b> -->
                            <a [routerLink]="['/features/publication-readiness-checks']">
                                阅读更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>引文检查器</h3>
                            <p>引文检查器可以识别那些会削弱您研究前提和论证的引文，并帮助您为您的论文引用可信的、权威的引文。
                            </p>
                            <a [routerLink]="['/features/citation-checker']">
                                阅读更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="citationCheckAllFeaturSection">
                            <img src="assets/images/CitationCheckAllFeaturePage.png" />
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>一致性检查</h3>
                            <p>您可能找到了一个更好的词来表达您的观点，但手稿中可能有些地方使用了连字符，另外一些地方却没有使用连字符。请放心，Trinka的“一致性检查”会检测到整个文本中的这种不一致，无论长度如何，您都可以进行一键修改。</p>
                            <a [routerLink]="['/features/consistency-check']">
                                阅读更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content consistency_checks_slider">
                            <div class="consistency_checks_slider_overlay"></div>
                            <!-- <img src="assets/images/consistencyCheck_img.png" alt=""> -->
                            <div class="slider_consistency_check_section">
                                <div id="consistencySlider" class="carousel slide" data-ride="carousel">
                                    <ul class="carousel-indicators">
                                        <li data-target="#consistencySlider" data-slide-to="0" class="active"></li>
                                        <li data-target="#consistencySlider" data-slide-to="1"></li>
                                        <li data-target="#consistencySlider" data-slide-to="2"></li>
                                        <li data-target="#consistencySlider" data-slide-to="3"></li>
                                        <li data-target="#consistencySlider" data-slide-to="4"></li>
                                    </ul>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Dashes</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                                            <label for="ultra-violet">ultra-violet (5 occurrences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="ultra_violet" name="dashesCehcks">
                                                            <label for="ultra_violet">ultra violet (5 occurrences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler alerts" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spacing</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                                            <label for="addSpaicng">Add space</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>p
                                                                <0 <img src="assets/images/spacingArrow.png" />p
                                                                < 0 </li>
                                                                    <li>p=0
                                                                        <img src="assets/images/spacingArrow.png" />p = 0 </li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="spacingChecks">
                                                            <label for="removingspacing">Remove space</label>
                                                        </p>
                                                        <ul>
                                                            <li>2D + DBT
                                                                <img src="assets/images/spacingArrow.png" />2D+DBT</li>
                                                            <li>p
                                                                < 0 <img src="assets/images/spacingArrow.png" />p
                                                                <0</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Numbers</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="spelledOut" name="numberschecks" checked>
                                                            <label for="spelledOut">Spelled-out
                                                                <img src="assets/images/spacingArrow.png" /> Numeral</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>average six years
                                                                <img src="assets/images/spacingArrow.png" />average 6 years </li>
                                                            <!-- <li>average 6 years <img src="assets/images/spacingArrow.png"/>average six years </li> -->
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="numeralSection" name="numberschecks">
                                                            <label for="numeralSection">Numeral
                                                                <img src="assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>waited 5 days
                                                                <img src="assets/images/spacingArrow.png" />waited five days</li>
                                                            <!-- <li>p < 0 <img src="assets/images/spacingArrow.png"/>p<0</li> -->
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Spelling</h2>
                                                    <div class="custom_radioButtons">
                                                        <p>
                                                            <input type="radio" id="colourSection" name="spellingchecks" checked>
                                                            <label for="colourSection">colour (4 occurences) </label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="colorSections" name="spellingchecks">
                                                            <label for="colorSections">color (4 occurences) </label>
                                                        </p>
                                                    </div>
                                                    <button>Apply selected variant</button>
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="carousel-item">
                                            <div class="carousel_inner_content">
                                                <div class="consistency_right_text">
                                                    <h2>Greek Letter Style</h2>
                                                    <div class="custom_radioButtons">
                                                        <p style="margin: 0;">
                                                            <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                                            <label for="GreekSpelledOut">Spelled-out
                                                                <img src="assets/images/spacingArrow.png" /> Symbol</label>
                                                        </p>
                                                        <ul style="margin-bottom: 20px;">
                                                            <li>TNF-alpha"
                                                                <img src="assets/images/spacingArrow.png" />tnf-α"</li>
                                                            <li>"Beta particles
                                                                <img src="assets/images/spacingArrow.png" />"β particles</li>
                                                        </ul>
                                                        <p style="margin: 0px;">
                                                            <input type="radio" id="removingspacing" name="Greekletterstyle">
                                                            <label for="removingspacing">Symbol
                                                                <img src="assets/images/spacingArrow.png" /> Spelled-out</label>
                                                        </p>
                                                        <ul>
                                                            <li>TNF-α"
                                                                <img src="assets/images/spacingArrow.png" />TNF-alpha"</li>
                                                            <li>"β particles
                                                                <img src="assets/images/spacingArrow.png" />"beta particles</li>
                                                        </ul>
                                                    </div>
                                                    <!-- <button>Apply selected variant</button> -->
                                                </div>
                                                <div class="consistency_left_side">
                                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    <ul>
                                                        <li>
                                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                                        </li>
                                                        <li>
                                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <span>
                                            <i class="fa fa-plus"></i>Add to dictionary</span>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <!-- <li><img src="assets/images/Consistency_IgnoreAll_Icons.svg" title="Ignore for all similler aterls" style="width: 22px;"></li> -->
                                        <li>
                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>

                            </div>
                            <!-- <img src="assets/images/personalDictionary_img.png" alt=""> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>个人词典</h3>
                            <p>将自己的单词添加到“我的词典”中，这样Trinka就不会在将来的写作中将其标记为拼写错误。</p>
                            <a [routerLink]="['/features/personal-dictionary']">
                                阅读更多
                                <img src="assets/images/ReadMoreArrow.png" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections downloadTrackedchangesOuter_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>下载开启了修订功能的文件</h3>
                            <p>下载经过修订的文件，该文件显示了您在Trinka编辑工具中选择的各项更改。</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="forMobileDownloadTrackChanges">
                            <img src="assets/images/DownloadFileTrackChanges.png" />
                        </div>
                        <div class="toolbox_img_content downloadTrackedchanges_section">
                            <!-- <img src="assets/images/downloadTrackedChanged_img.png" alt=""> -->
                            <div class="downloadCleanFile">
                                <!-- <p class="cleanDownloadfile"></p> -->
                                <p class="OpenSansFonts">
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                            <div class="downloadWithTrackedChangesFile">
                                <!-- <p class="TrackedChangesFile"></p> -->
                                <p class="OpenSansFonts">
                                    <span class='wrognWordText'>On the other hand </span>
                                    <span class='rightWordTExt'>However,</span> additional factors
                                    <span class='wrognWordText'>which influence </span>
                                    <span class='rightWordTExt'>influencing</span> patient prognosis and
                                    <span class='wrognWordText'>leading to a reduction in </span>
                                    <span class='rightWordTExt'>reducing</span> HDL-C and Apo A1 levels were assessed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections publication_outer_sections personal_outer_section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content publication_checks_section pd_after">
                            <div class="personal_dictionary_section">
                                <div class="personal_dic_left_text">
                                    <h2>Spelling
                                        <b>
                                            <i class="fa fa-plus"></i>Add to dictionary</b>
                                    </h2>
                                    <div class="personal_dic_text_section">
                                        <p class="personal_wrong_text">nanotubol</p>
                                        <img src="assets/images/spacingArrow.png" />
                                        <p class="personal_right_text">nanotubes</p>
                                    </div>
                                    <div class="acceptAll_buttons_sections">
                                        <p>Accept for all similar alerts</p>
                                        <i>
                                            <img src="assets/images/info.svg" alt="">
                                        </i>
                                    </div>
                                    <p>Please check the spelling</p>
                                </div>
                                <div class="consistency_left_side">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <ul>
                                        <li>
                                            <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                        </li>
                                        <li class="acceptAll_rejectAll">
                                            <img src="assets/images/AcceptAll_consistencyCheks.svg" title="Ignore for all similler aterls" style="width: 22px;">
                                        </li>
                                        <li>
                                            <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h3>全部接受/全部忽略</h3>
                            <p>不再需要重复点击！ Trinka允许一键接受或忽略所有重复性建议。</p>
                            <!-- <a href="">Read More</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="forpersonlized_sections">
        <p>您还在等什么？</p>
        <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">免费注册！</a>
    </div>
</div>